/* eslint-disable no-nested-ternary */
// @flow
// libs
import React, { memo } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/Button';
import images from 'themes/images';

type Props = {
  title?: string,
  children: any,
  animation?: boolean,
  isOpen: boolean,
  size?: string,
  handleClose: Function,
  customClass?: string,
  isShowIconClose?: boolean,
  isShowHeader?: boolean,
  isShowFooter?: boolean,
  isShowTwoBtn?: boolean,
  customClassButton?: string,
  classNameBtnLeft?: string,
  textBtnLeft?: string,
  classNameBtnRight?: string,
  textBtnRight?: string,
  handleSubmit?: Function,
  isDisabledButton?: boolean,
  handleCloseOvl?: Function,
  isShowIconCloseB?: boolean,
  onShoModal:Function
};

export const ModalPopup = ({
  title = '',
  children,
  animation = false,
  isOpen,
  size,
  handleClose,
  customClass,
  isShowIconClose,
  isShowHeader,
  isShowFooter,
  isShowTwoBtn,
  customClassButton = '',
  classNameBtnLeft = '',
  textBtnLeft = '',
  classNameBtnRight = '',
  textBtnRight = '확인',
  handleSubmit = () => {},
  handleCloseOvl = () => {},
  isDisabledButton,
  isShowIconCloseB,
  onShoModal = () => {},
}: Props) => (
  <Modal
    animation={animation}
    onHide={handleCloseOvl}
    show={isOpen}
    size={size}
    className={customClass}
    onShow={onShoModal}
  >
    {isShowIconClose && (
      <div
        className="modal-content__iconClose"
        onClick={handleClose}
        role="button"
        tabIndex={0}
        onKeyUp={handleClose}
      >
        <img src={images.icon_close_img_preview}  className='icon-close-pre' alt="" />
      </div>
    )}

    {isShowIconCloseB && (
      <div
        className="modal-content__iconClose-B"
        onClick={handleClose}
        role="button"
        tabIndex={0}
        onKeyUp={handleClose}
      >
        <img src={images.icon_close_B} alt="" />
      </div>
    )}

    {isShowHeader && title && <h3 className="modal-title">{title}</h3>}

    <Modal.Body>
      {!isShowHeader ? (
        <div className="modal-body__no-header">{children}</div>
      ) : (
        <div className="modal-body__has-header">{children}</div>
      )}
    </Modal.Body>
    {isShowFooter && (
      <Modal.Footer>
        {!isShowTwoBtn ? (
          <Button
            type="button"
            customClass={customClassButton}
            onClick={handleClose}
            isDisabled={isDisabledButton}
          >
            {textBtnRight}
          </Button>
        ) : (
          <div className="group-button">
            <Button
              type="button"
              customClass={`button--half btn-left ${customClassButton} ${classNameBtnLeft}`}
              onClick={handleClose}
              isDisabled={isDisabledButton}
            >
              {textBtnLeft}
            </Button>
            <Button
              type="button"
              customClass={`button--half btn-right ${customClassButton} ${classNameBtnRight}`}
              onClick={handleSubmit}
            >
              {textBtnRight}
            </Button>
          </div>
        )}
      </Modal.Footer>
    )}
  </Modal>
);

ModalPopup.defaultProps = {
  title: '',
  animation: false,
  size: '',
  customClass: '',
  isShowIconClose: false,
  isShowHeader: false,
  isShowFooter: false,
  isShowTwoBtn: false,
  customClassButton: '',
  classNameBtnLeft: '',
  textBtnLeft: '',
  classNameBtnRight: '',
  textBtnRight: '확인',
  handleSubmit: () => {},
  isDisabledButton: false,
  handleCloseOvl: () => {},
  isShowIconCloseB: false,
  onShoModal: () => {},
};
export default memo<Props>(ModalPopup);
